import { CatalogItemViewModel } from '@common/model/catalog/item/view';

export const getResumeAddress = (model: CatalogItemViewModel): string => {
  const parts = [model.city?.translation.name, model.address];
  return parts.filter(Boolean).join(', ');
};
